import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import DOMPurify from 'dompurify'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faCopy, faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify'
import DireccionCard from './DireccionCard'
import MetodosPagoList from './MetodosPagoList'
import ComprovanteTransfEnviado from './ComprovanteTransfEnviado'
import CodigoAutForm from './CodigoAutForm'
import FormDirEnvio from './FormDirEnvio'
import TotalPedido from './TotalPedido'
import { fetchNewDireccionCheckout, fetchRecalculatePresupuesto, fetchSaveNotasInfo, fetchSaveSelectedDireccion, fetchShippingPrice, fetchUpdateClienteCheckout, fetchUpdateDireccionCheckout } from '../../../../../../../redux/checkout'
import Resume from './Resume'
import './carrito.scss'
import Pago from './Pago'
import { ConfirmModal } from '../../../../../../shared/components/ConfirmModal'
import Spinner from './shared/components/Spinner'
import useScreenWidth from '../../../../../../../hooks/useScreenWidth'
import { setErrorMessage } from '../../../../../../../shared/helpers/functionalities'
import { isAddressOutOfRange, wichIVA } from '../../../../../../shared/helpers/functionalities'
import { payWithBizum, payWithCredit, payWithCreditCard, payWithTransfer, payWithoutPayment, updateTransferenciaMethod } from '../../../../../../../shared/services/checkout'
import InfoModal from '../../../../../../shared/components/InfoModal'
import PagoCascoDetails from './PagoCascoDetails'

const Carrito = () => {
  const checkoutInfo = useSelector(state => {
    return state.checkout.entity
  });
  
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const screenWidth = useScreenWidth()
  const formRef = useRef()
  const notasRef = useRef()
  const facturacionRef = useRef()
  const envioRef = useRef()
  const formEnvioRef = useRef()
  const [dirEnvio, setDirEnvio] = useState(null)
  const [isOpenForm, setIsOpenForm] = useState(false)
  const [dirFacturacion, setDirFacturacion] = useState({
    nombre: checkoutInfo.cliente.nombre,
    telefono: checkoutInfo.cliente.telefono,
    email: checkoutInfo.cliente.email,
    direccion: checkoutInfo.cliente.direccion_facturacion,
    codigo_postal: checkoutInfo.cliente.codigo_postal_facturacion,
    poblacion: checkoutInfo.cliente.poblacion_facturacion,
    area: checkoutInfo.cliente.area_facturacion,
    pais_id: checkoutInfo.cliente.pais_facturacion_id,
    cif: checkoutInfo.cliente.cif,
    tipo_cliente_id: checkoutInfo.cliente.tipo_cliente_id,
    cif_ue: checkoutInfo.cliente.pais_facturacion_id === 1 ? false : checkoutInfo.cliente.cif_ue
  })
  
  const [isOpenDirFacturacion, setIsOpenDirFacturacion] = useState(false)
  const [paymentType, setPaymentType] = useState()
  const [paymentForm, setPaymentForm] = useState(null);
  const [paymentStep, setPaymentStep] = useState(null)
  const [isConcidionesChecked, setIsConcidionesChecked] = useState(false);
  const [isCascoChecked, setIsCascoChecked] = useState(false);
  const [isCascoOptionChecked, setIsCascoOptionChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingSelectDirEnvio, setIsLoadingSelectDirEnvio] = useState(false)
  const [dirsEnvioArray, setDirsEnvioArray] = useState(checkoutInfo.direcciones)
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)
  const [openCascoDetails, setOpenCascoDetails] = useState(false);

  useEffect(() => {
    if (checkoutInfo.presupuesto.transferencia) {
      return setPaymentType(3)
    } else if(checkoutInfo.presupuesto.efectivo) {
      return setPaymentType(5)
    } else {
      return setPaymentType(1)
    }
  }, [])
  
  useEffect(() => {
    if(!dirEnvio) {
      if (checkoutInfo.presupuesto.direccion_envio_id) {
        const direccion = checkoutInfo?.direcciones.find(dir => dir.id === checkoutInfo.presupuesto.direccion_envio_id)
        setDirEnvio(direccion)
      } else {
        if (checkoutInfo?.direcciones?.length === 0){
          setDirEnvio('otra')
          setIsOpenForm(true)
        }       
      }
    }
    if (!checkoutInfo.presupuesto.ecommerce) {
      if (checkoutInfo.presupuesto.direccion_envio_id && dirEnvio && dirEnvio !== 'otra' && dirsEnvioArray.length > 0) {
        const direccion = checkoutInfo?.direcciones.find(dir => dir.id === checkoutInfo.presupuesto.direccion_envio_id)
        if (direccion.pais_id !== dirEnvio.pais_id) {
          setDirEnvio(direccion)
          toast.error(t('errors.diferente'))
        }
      }
    }
  }, [dirEnvio])

  useEffect(() => {
    if(checkoutInfo.presupuesto.ecommerce) {
      if(!checkoutInfo.presupuesto.direccion_envio_id) setDirEnvio(null) 
    }
  }, [checkoutInfo.presupuesto.direccion_envio_id])
  

  const handleSearchDirsEnvio = (e) => {
    const searchedDirs = checkoutInfo?.direcciones.filter(dir => (dir.nombre.toLowerCase()).includes((e.target.value).toLowerCase()) || (dir.direccion.toLowerCase()).includes((e.target.value.toLowerCase())))
    setDirsEnvioArray(searchedDirs)
  }
  
  const handleEdit = (direccion) => {
    if(direccion === 'facturacion') {
      const telf = checkoutInfo.cliente.telefono?.length > 12 ? checkoutInfo.cliente.telefono.split(' ')[0] : checkoutInfo.cliente.telefono;
      const dirFact = {
        nombre: checkoutInfo.cliente.nombre,
        telefono: telf,
        email: checkoutInfo.cliente.email,
        direccion: checkoutInfo.cliente.direccion_facturacion,
        codigo_postal: checkoutInfo.cliente.codigo_postal_facturacion,
        poblacion: checkoutInfo.cliente.poblacion_facturacion,
        area: checkoutInfo.cliente.area_facturacion,
        pais_id: checkoutInfo.cliente.pais_facturacion_id,
      };
      setDirEnvio(dirFact);
    } else {
      setDirEnvio(direccion)
    }
    
    setIsOpenForm(true)
    setTimeout(() => {
      formRef?.current?.lastElementChild?.scrollIntoView({ behavior: 'smooth' })
    }, 1);
  }

  const handleEditSchedule = (e, direccion) => {
    e.stopPropagation()
    setDirEnvio(direccion)
    setIsOpenForm(true)
    setTimeout(() => {
      formRef.current.lastElementChild.scrollIntoView({ behavior: 'smooth' })
    }, 1);
  }
  
  const updateDirectionSchedule = async(data) => {
    if (checkoutInfo.presupuesto.direccion_envio_id !== data.id) handleDirEnvio(data)
    dispatch(fetchUpdateDireccionCheckout(checkoutInfo.presupuesto.checkout_id, {...data, entity_id: checkoutInfo.cliente.id}))
    const newDirArr = dirsEnvioArray.map(dir => dir.id === data.id ? {...dir, horario_entrega_dia: data.horario_entrega_dia, horario_entrega_tarde: data.horario_entrega_tarde } : dir)
    setDirsEnvioArray(newDirArr)
    setIsOpenForm(false)
    handleSelectDirEnvio()
  }

  const addNewDirection = async (data) => {
    await dispatch(fetchNewDireccionCheckout(checkoutInfo.presupuesto.checkout_id, data))
    const newDir = checkoutInfo?.direcciones.reduce((accumulator, currentValue) => {
      return currentValue.id > accumulator.id ? currentValue : accumulator
    }, checkoutInfo.direcciones[0])
    setDirsEnvioArray(checkoutInfo.direcciones)
    handleDirEnvio(newDir)
    setIsOpenForm(false)
    handleSelectDirEnvio()
  }
  
  useEffect(() => {
    const valid = Object.values(dirFacturacion).every(
      value => value !== '' && value !== null && value !== undefined);
    setIsOpenDirFacturacion(!valid)
  }, [dirFacturacion])
  
  const handleDirFactClient = async(data) => {
      await dispatch(fetchUpdateClienteCheckout(checkoutInfo.presupuesto.checkout_id, {...data, id: checkoutInfo.cliente.id}));   
      handleCheckIfHasToChangeIva(data.cif_ue)
      setDirFacturacion(data)
      toast.success(t('success-msg.datos-facturacion'));
  }

  const handleCheckIfHasToChangeIva = (isCifUe) => {
    const { direccion_envio_id, iva, checkout_id, id } = checkoutInfo.presupuesto
    if(direccion_envio_id) {
      const address = checkoutInfo?.direcciones.find(address => address.id === direccion_envio_id)
      if(wichIVA(dirFacturacion, address, isCifUe) !== iva ) {
        dispatch(fetchRecalculatePresupuesto(id, checkout_id))
      } 
    }
  }

  const checkAllIsChecked = () => {
    const valid = Object.values(dirFacturacion).every(
      value => value !== '' && value !== null && value !== undefined);
    if(!valid) {
      screenWidth >= 992 ? toast.error(t('errors.facturacion')) : setIsErrorModalOpen('facturacion')
      return false
    }
    
    if(!dirEnvio || dirEnvio === 'otra') {
      screenWidth >= 992 ? toast.error(t('errors.envio')) : setIsErrorModalOpen('envio')
      return false
    }

    if(isOpenForm) {
      screenWidth >= 992 ? toast.error(t('errors.form-abierto')) : setIsErrorModalOpen('form-abierto')
      return false
    }

    if(!checkoutInfo?.presupuesto?.servicios_envio[0]?.servicio_envio_id 
      || !checkoutInfo?.presupuesto?.direccion_envio_id) {
        screenWidth >= 992 ? toast.error(t('errors.shipping')) : setIsErrorModalOpen('shipping')
        return false
    }

    return true
  }

  const handleCloseErrorModal = () => {
    if (isErrorModalOpen === 'envio') {
      envioRef && envioRef.current.scrollIntoView({behavior: 'smooth'})
    } else if (isErrorModalOpen === 'facturacion') {
      facturacionRef && facturacionRef.current.scrollIntoView({behavior: 'smooth'})
    } else if (isErrorModalOpen === 'form-abierto') {
      formEnvioRef && formEnvioRef.current.scrollIntoView({behavior: 'smooth'})
    }
    setIsErrorModalOpen(false)
  }

  const submitOrder = () => {
    const isAllChecked = checkAllIsChecked()
    if(!isAllChecked) return
    
    if(!paymentType) {
      return screenWidth >= 992 ? toast.error(t('errors.pago')) : setIsErrorModalOpen('pago')
    } 

    if(isAllChecked && paymentType) {
      if(notasRef.current.value !== checkoutInfo.presupuesto.observaciones_cliente) dispatch(fetchSaveNotasInfo({notas: notasRef.current.value, presupuesto_id: checkoutInfo.presupuesto.id}))
      if(checkoutInfo.presupuesto.total_iva === 0) {
        dispatch(fetchSaveSelectedDireccion(checkoutInfo.presupuesto.checkout_id, dirEnvio.id));
        noPayment();
      } else {
        setIsLoading(true)

        if(paymentType === 1 || paymentType === 2) {
          return checkout();
        }
        
        if(paymentType === 3 || paymentType === 5) return  transferencia();
      }
    }
  }

  const noPayment = async() => {
    setIsLoading(true)
    const response = await payWithoutPayment(checkoutInfo.presupuesto.checkout_id, {
      tipo_pago_id: paymentType,
      recogida_casco: isCascoChecked
    })
    .catch(function (error) {
        toast.error(setErrorMessage(error))
    });

    if(response && response.success) {
      setIsLoading(false)
      window.location.reload();
    }
  }

  const transferencia = async() => {
    await updateTransferenciaMethod(checkoutInfo.presupuesto.id, {
      tipo_pago_id: paymentType,
      recogida_casco: isCascoChecked
    })
    .catch(function (error) {
      toast.error(setErrorMessage(error))
    });
    setPaymentStep(1)
    return setIsLoading(false)
  }

  const checkout = async() => {
    let response;
    dispatch(fetchSaveSelectedDireccion(checkoutInfo.presupuesto.checkout_id, dirEnvio.id));

    if(paymentType === 1) {
      response = await payWithCreditCard(checkoutInfo.presupuesto.checkout_id, {
        recogida_casco: isCascoChecked
      })
      .catch(function (error) {
        toast.error(setErrorMessage(error))
      });
    }

    if(paymentType === 2) {
      response = await payWithBizum(checkoutInfo.presupuesto.checkout_id, {
        recogida_casco: isCascoChecked
      })
      .catch(function (error) {
        toast.error(setErrorMessage(error))
      });
    }
    
    if(response) {
      setPaymentForm(DOMPurify.sanitize(response));
    }
    
    setPaymentStep(1)
    return setIsLoading(false)
  }

  const handleCreditoPayment = async(data) => {
    const isAllChecked = checkAllIsChecked()
    if(isAllChecked) {
      const response = await payWithCredit(
        checkoutInfo.presupuesto.checkout_id, 
        {
          direccion_envio_id: dirEnvio?.id, 
          codigo_autorizacion: data.codigo_autorizacion
        }
      ).catch(function (error) {
        toast.error(setErrorMessage(error))
      });
  
      if(response && response.success) {
        window.location.reload();
      }
    }
  }

  const handleUploadComprobante = async(data) => {
    data.append('direccion_envio_id', dirEnvio?.id);
    const response = await payWithTransfer(checkoutInfo.presupuesto?.checkout_id, data)
      .catch(function (error) {
        toast.error(setErrorMessage(error))
      });

    if(response && response.success) {
      setPaymentStep(2);
    }
  }

  const handleDirEnvio = async (direccion) => {
    if(isLoadingSelectDirEnvio) return
    setIsLoadingSelectDirEnvio(direccion.id)
    if(checkoutInfo.presupuesto.ecommerce && checkoutInfo?.presupuesto?.created_by?.username !== 'perito_mutua') {
      const res = await dispatch(fetchShippingPrice(checkoutInfo.presupuesto.id, direccion))
      if (!res) {
        setDirEnvio(null)
        return setIsLoadingSelectDirEnvio(false)
      }
    } else {
      await dispatch(fetchSaveSelectedDireccion(checkoutInfo.presupuesto.checkout_id, direccion.id));
    }
    setIsLoadingSelectDirEnvio(false)
    setDirEnvio(direccion)
  }

  const handleSelectDirEnvio = () => {
    envioRef && envioRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  const handleSelectDirFact = () => {
    facturacionRef && facturacionRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  const handleCheckIfIsValid = () => {
    if(checkoutInfo?.presupuesto?.piezas.find(p => p.tipo_pieza_id === 406)) {
      const descuento = calcularDescuentoCasco();

      if(descuento > 0) {
        return !isConcidionesChecked || !isCascoOptionChecked
      } else return !isConcidionesChecked
    } else return !isConcidionesChecked;
  }

  const handleOpenCascoDetails = () => setOpenCascoDetails(true);
  const handleCloseCascoDetails = () => setOpenCascoDetails(false);
  const calcularDescuentoCasco = () => {
    const direccion = checkoutInfo?.direcciones.find(dir => dir.id === checkoutInfo.presupuesto?.direccion_envio_id)
    const motor = checkoutInfo?.presupuesto?.piezas.find(p => p.tipo_pieza_id === 406 && p.casco === 0);

    if(motor && direccion) {
      const precioMotor = motor.precio_venta;
      let descuento;

      if(direccion.pais_id === 1) {
        descuento = Math.floor(precioMotor / 1000) * 50;
      } else {
        descuento = Math.floor(precioMotor / 2000) * 50;
      }

      return descuento;
    } else return null;
  }
  
  return <div className='carrito'>
        {!paymentStep && 
          <div>
            <div className='w-100'>
              <section className='carrito__detalle'>
                  <Resume checkoutInfo={checkoutInfo} />
              </section>

              <section className='carrito__facturacion' ref={facturacionRef}>
                  <h2>{t('carrito.facturacion.title')}</h2>
                  {isOpenDirFacturacion ?
                  <FormDirEnvio 
                    dirEnvio={dirFacturacion}
                    isDirFact={true}
                    uploadDirection={handleDirFactClient}
                    />
                  : <DireccionCard
                      direccion={checkoutInfo.cliente}
                      isSelected={true}
                      isDirEnvio={false}
                  />}
                  <p className='carrito__facturacion--info'><span><FontAwesomeIcon icon={faCircleInfo} /></span> {t('carrito.facturacion.cambiar')}</p>
              </section>

              <section className='carrito__envio' ref={envioRef}>
                  <h2 className='carrito__envio--title'>{t('carrito.envio.title')} {!dirEnvio && <span className='carrito__envio--select-address'>{t('carrito.envio.select-dir')}</span>}</h2>
                  {checkoutInfo?.direcciones?.length > 6 &&
                    <div className='carrito__envio--search'>
                      <input type='text' onChange={handleSearchDirsEnvio} className='carrito__envio--search--input' placeholder='Escribe la dirección a buscar'/>
                      <span className='carrito__envio--search--icon'><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                    </div>
                  }
                  {dirsEnvioArray?.length > 0 && <div ref={formRef} className='carrito__envio--direcciones'>
                    {dirsEnvioArray.length > 0 && dirsEnvioArray.map(direccion => (
                      <DireccionCard
                          key={direccion.id}
                          direccion={direccion}
                          isSelected={ dirEnvio?.id === direccion.id }
                          setDirEnvio={handleDirEnvio}
                          setIsOpenForm={setIsOpenForm}
                          handleEditSchedule={handleEditSchedule}
                          isOutOfRange={checkoutInfo.presupuesto.ecommerce ? isAddressOutOfRange(direccion.codigo_postal, direccion.pais_id) : false}
                          isLoadingSelectDirEnvio={isLoadingSelectDirEnvio} 
                        />
                    ))}
                  </div>}

                  {((checkoutInfo?.direcciones?.length === 0 && !isOpenDirFacturacion) || checkoutInfo?.direcciones?.length > 0) && <div className='carrito__envio--add-address'>
                      { (checkoutInfo?.direcciones?.length === 0 && !isOpenDirFacturacion) && 
                        <button className='carrito__envio--add-address--btn me-3' onClick={() => handleEdit('facturacion')}><span><FontAwesomeIcon icon={faCopy} /></span>{t('carrito.direccion.copiar-facturacion')}</button>
                      }
                      { checkoutInfo?.direcciones?.length > 0 && <button className='carrito__envio--add-address--btn' onClick={() => handleEdit('otra')}><span><FontAwesomeIcon icon={faPlus} /></span>{t('carrito.direccion.nueva')}</button>}
                  </div>}
                  { (isOpenForm || checkoutInfo?.direcciones?.length === 0) &&
                    <FormDirEnvio
                        formEnvioRef={formEnvioRef}
                        dirEnvio={dirEnvio}
                        addNewDirection={addNewDirection}
                        uploadDirection={updateDirectionSchedule}
                        isOpenDirFacturacion={isOpenDirFacturacion}
                        handleSelectDirFact={handleSelectDirFact}
                      />
                  }
              </section>
            </div>

            <section className='carrito__pedido'>
                <div>
                    <TotalPedido handleSelectDirEnvio={handleSelectDirEnvio}/>
                    {checkoutInfo.cliente.credito 
                      ? <CodigoAutForm
                          conCodigo={checkoutInfo.cliente.con_codigo === 0 ? false : true}
                          presupuesto={checkoutInfo.presupuesto}
                          onSubmitCodigoAut={handleCreditoPayment} 
                          cliente={checkoutInfo.cliente}
                          /> 
                      : <>
                          <MetodosPagoList checkoutInfo={checkoutInfo} paymentType={paymentType} setPaymentType={setPaymentType} />
                          <div className='carrito__pedido--textarea'>
                              <textarea id='notas' ref={notasRef} defaultValue={checkoutInfo.presupuesto.observaciones_cliente} placeholder={t('carrito.pedido.notas')} />
                          </div>
                          <div className='carrito__pedido--submit'>
                              <div>
                                  <input type='checkbox' checked={isConcidionesChecked} onChange={(e) => setIsConcidionesChecked(e.target.checked)}/>
                                  <p>
                                      {t('carrito.pedido.condiciones.1')}
                                      <Link to={"/condiciones"} title="Condiciones Generales de Compra" target={"_blank"}><b> {checkoutInfo.cliente.ecommerce ? t('carrito.pedido.condiciones.2') : t('carrito.pedido.condiciones.3')}</b></Link>
                                  </p>
                              </div>

                              { (calcularDescuentoCasco()) ?
                                <div className='my-2 flex-column'>
                                  <div className='d-flex align-items-start'>
                                    <p className='pe-3'>
                                        {t('carrito.pedido.casco.1')} 
                                        <b>
                                          {calcularDescuentoCasco()}
                                        </b> 
                                        {t('carrito.pedido.casco.2')} 
                                    </p>
                                  </div>

                                  <div className='w-100 d-flex align-items-center justify-content-between gap-2'>
                                    <div className='w-auto'>
                                      <span className='d-flex align-items-center'>
                                        <input type='radio' name="casco" value="si" onChange={() => { setIsCascoChecked(true); setIsCascoOptionChecked(true); }}/>
                                        <label className='ms-1'>{t('carrito.pedido.casco.4')}</label>
                                      </span>
                                      <span className='d-flex align-items-center'>
                                        <input type='radio' name="casco" value="no" onChange={() => { setIsCascoChecked(false); setIsCascoOptionChecked(true); }}/>
                                        <label className='ms-1'>{t('carrito.pedido.casco.5')}</label>
                                      </span>
                                    </div>

                                    <p className='flex-grow-1 p-0'>
                                      <span 
                                        className='fw-bold text-decoration-underline' 
                                        style={{cursor: 'pointer'}}
                                        onClick={() => handleOpenCascoDetails()}
                                      >
                                        {t('carrito.pedido.casco.3')}
                                      </span>
                                    </p>
                                  </div>

                                  <div>
                                    
                                  </div>
                                </div>
                                : null
                              }
                              <button disabled={handleCheckIfIsValid()} onClick={submitOrder}>{isLoading ? <Spinner className='spinner-pedido-section'/> : t('carrito.pedido.submit')}</button>
                          </div>
                        </>}
              </div>
            </section>
          </div>
        }
        { (openCascoDetails) &&
          <InfoModal 
            width={"md"}
            state={openCascoDetails}
            title={t('carrito.pedido.casco.info.title')}
            content={
              <PagoCascoDetails />
            }
            onClose={handleCloseCascoDetails}
          />
        }
        {isErrorModalOpen && <ConfirmModal text={t(`errors.${isErrorModalOpen}`)} handleCloseErrorModal={handleCloseErrorModal} />}
        {paymentStep === 1 && <Pago 
              checkoutInfo={checkoutInfo} 
              paymentType={paymentType}
              paymentForm={paymentForm}
              setPaymentStep={setPaymentStep}
              onUploadComprobante={handleUploadComprobante} />}
        {paymentStep === 2 && <ComprovanteTransfEnviado checkoutInfo={checkoutInfo} />}
    </div>
}

export default Carrito
